module.exports = __webpack_public_path__ + "e1e58c255f1f91ce73dfc7e7901de32c.mp3";